import {EmptyAlert} from '../EmptyAlert';
import {ErrorLoadingData} from '../ErrorLoadingData';
import {CellPhoneData} from './Data';
import {CellPhoneForm} from './Form';

const CellPhone = {
	Data: CellPhoneData,
	Form: CellPhoneForm,
	Empty: EmptyAlert,
	Error: ErrorLoadingData,
};

export {CellPhone};
